/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren, ChangeDetectionStrategy} from '@angular/core';
import {InputComponent} from '../input/input.component';
import {UntypedFormBuilder} from '@angular/forms';
import {InputControl} from '../input/input-control';

@Component({
    selector: 'app-input-radio',
    templateUrl: './input-radio.component.html',
    styleUrls: ['../input/input.component.css', './input-radio.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputRadioComponent<T> extends InputComponent {
    @Input() options: T[];
    @Input() baseCypressTag = 'input-radiobox';

    @ViewChildren('inputOption') inputOptions: QueryList<ElementRef>;

    // TODO: CTWILS-3963 - The following verify that the TODOs marked in the parent component can be applied.
    //       In this case we remove the string union type because it's impossible for the value being emitted to ever be
    //       a string as the user can't input text on a radio input, unless the generic type being emitted is a string.
    @Input() initialValue: T = null;
    @Output() inputStateChange = new EventEmitter<InputControl<T>>();
    @Output() inputStatusChange = new EventEmitter<T>();
    @Output() inputValueChange = new EventEmitter<T>();

    constructor(fromBuilder: UntypedFormBuilder) {
        super(fromBuilder);
    }

    // TODO: CTWILS-3963 - The following verifies that the TODOs marked in the parent component can be applied.
    setValue(value: T, options?: { emitEvent: boolean }): void {
        super.setValue(value, options);

        // We have to force the click in order to update the selected option. Radio buttons are weird.
        this.inputOptions
                ?.find((_element, index) => index === this.options.indexOf(value))
                ?.nativeElement
                ?.click();
    }

    @Input() optionTransform(value: T): string {
        return value?.toString?.() ?? '';
    };

    isDefaultChecked(option: T): boolean {
        return option === this.initialValue;
    }

    optionInputCypressTag(index: number): string {
        return `${this.baseCypressTag}-input-${index ?? 0}`;
    }

    optionLabelCypressTag(index: number): string {
        return `${this.baseCypressTag}-label-${index ?? 0}`;
    }
}
